// @ts-check
import RequestService from './request-service';

/**
 * Boosted Odds Request Service
 */
export default class TopEventsRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.topEvents;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';

    /**
     * Set get params
     * @type {{platform: import('bto-models/top-events/interface').ITopEventsPlatform, culture: string}}
     */
    this.getParams = {
      platform: getTopEventsPlatform(),
      culture: APP_SETTINGS.player.language || 'en',
      // timeOffset: new Date().getTimezoneOffset(),
    };
    this.headers = null;
  }
}

function getTopEventsPlatform() {
  if (process.env.VUE_APP_IS_MOBILE) {
    return 2;
  }
  if (process.env.VUE_APP_IS_AGENT) {
    return 4;
  }
  if (APP_SETTINGS && APP_SETTINGS.settings && APP_SETTINGS.settings.isSSBT) {
    return 3;
  }
  return 1;
}